"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagVI = function FlagVI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.25,39.39l2.57,9,9-26.63L112.93,34.91,122.27,36,92.45,71l-.25-.74L116,21l4.78,8.11,1.95-28L102,20l9.32-1.3L87.5,68l-.74.26,8.9-45.14,6.66,6.63L97.14,2.18,81.86,25.75l8.68-3.61-9.6,48.67L77.81,77.3l-3.38,2.27-1.39,7L61.23,100.48l9.22-.74-1.67,8.48L72,106l.32,3.91,5.6-6.58,5.15,7.68,3.52-17.88,4.65-5.46L91,83.65l3.13-6.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-88.27,12.92c1-4.55.39-8.82-1.34-11.44-2.69,1.64-5.07,5.24-6.08,9.79a19.07,19.07,0,0,0-.37,6L-101.64,9a16.12,16.12,0,0,0,5.12-9c1-4.55.38-8.82-1.35-11.45-2.69,1.65-5.06,5.24-6.08,9.8a18.62,18.62,0,0,0-.27,6.8L-108-.53a16.46,16.46,0,0,0-2.79-9.63c-2.51-3.94-6-6.51-9-7.14-.74,3.06.13,7.29,2.63,11.22A16.34,16.34,0,0,0-109.57.56l3.46,5.74a18.62,18.62,0,0,0-6.29-2.64c-4.55-1-8.82-.38-11.44,1.35,1.64,2.69,5.24,5.06,9.79,6.08a16.15,16.15,0,0,0,10.33-.82l5.16,8.58a19.19,19.19,0,0,0-5.58-2.21c-4.55-1-8.82-.38-11.44,1.36,1.64,2.68,5.24,5.06,9.79,6.07a16.39,16.39,0,0,0,10-.65l4.76,7.9a18.87,18.87,0,0,0-5-1.89c-4.56-1-8.82-.39-11.45,1.35,1.64,2.68,5.24,5.06,9.8,6.08A16.88,16.88,0,0,0-88,36.37L-83.41,44a20,20,0,0,0-4.33-1.57c-4.56-1-8.82-.38-11.45,1.36,1.64,2.68,5.24,5,9.79,6.07a17.17,17.17,0,0,0,9.32-.33l4.18,6.94a19.71,19.71,0,0,0-3.71-1.25c-4.55-1-8.82-.39-11.45,1.35,1.65,2.68,5.24,5.06,9.8,6.07a17.36,17.36,0,0,0,9-.21l13.27,22,5.64-3.59L-67.73,59.5a17.46,17.46,0,0,0,4-8c1-4.55.38-8.81-1.35-11.44-2.68,1.64-5.06,5.24-6.07,9.79a19.86,19.86,0,0,0-.45,3.89L-76.11,47a17.29,17.29,0,0,0,4.24-8.3c1-4.55.38-8.82-1.35-11.45-2.69,1.65-5.06,5.25-6.08,9.8a19.35,19.35,0,0,0-.41,4.59l-5-7.38a16.87,16.87,0,0,0,4.53-8.54c1-4.55.38-8.82-1.35-11.45-2.68,1.65-5.06,5.24-6.08,9.8a19.8,19.8,0,0,0-.39,5.29l-5.13-7.65a16.45,16.45,0,0,0,4.81-8.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-30.57,12.18l-7.07-42.37h-1.09a9.39,9.39,0,0,1-8.91-12.36l0-.07A9.41,9.41,0,0,0-53.4-54.45l-97-34.22a6.68,6.68,0,0,0-8.37,8.94l10.51,24.53a35.28,35.28,0,0,0,14.94,16.75l26.89,15.38a53.21,53.21,0,0,0,26.39,7l2.42,4.83A42.36,42.36,0,0,0-39.7,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.17,12.18l7.06-42.37h1.1a9.39,9.39,0,0,0,8.91-12.36l0-.07A9.4,9.4,0,0,1,77-54.45l96.93-34.21a6.7,6.7,0,0,1,8.39,9L171.83-55.2a35.33,35.33,0,0,1-14.94,16.75L130-23.07a53.17,53.17,0,0,1-26.38,7h0l-2.4,4.83A42.39,42.39,0,0,1,63.3,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.05-37.25,22.53-78.13a14.13,14.13,0,0,0-13-8.56H4.74l-7.06,7.06H-9.39l-7.06,7.06h9.86A3.48,3.48,0,0,1-3.4-67.71l-13,30.46Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.39,33.37-23.51,12.18-36.45,25.11A49.6,49.6,0,0,0-48.39,44.44l-3.37,10.11-7.06,7.06H-68A8,8,0,0,0-75.16,66l-2,4a4,4,0,0,0,3.54,5.72h14.79l4.71-9.42L-31.6,55.06a7,7,0,0,0,1.84-1.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33,33.37,47.11,12.18,60,25.11A49.37,49.37,0,0,1,72,44.44l3.38,10.11,7.06,7.06H91.6A8,8,0,0,1,98.76,66l2,4a4,4,0,0,1-3.54,5.72H82.42l-4.71-9.42L55.2,55.06a7,7,0,0,1-1.84-1.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.39,40.43-26.55,69a9.14,9.14,0,0,0,2,11.71L1.5,102.46a16.09,16.09,0,0,0,20.6,0L48.16,80.74a9.12,9.12,0,0,0,2-11.71L33,40.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-44.32s-21.19,7.07-49.44,0v28.25c0,14.12,7.07,56.5,49.44,70.62C54.17,40.43,61.23-1.95,61.23-16.07V-44.32c-28.25,7.07-49.43,0-49.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-44.32s-21.19,7.07-49.44,0v28.25H61.23V-44.32c-28.25,7.07-49.43,0-49.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-22.87,29.11V-16.07h-7.7V15.37a76.24,76.24,0,0,0,7.7,13.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.46-16.07h-7.7V38.14a66.22,66.22,0,0,0,7.7,6.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.47,29.11a76.24,76.24,0,0,0,7.7-13.74V-16.07h-7.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.94-16.07H.24V49.48A74.68,74.68,0,0,0,7.94,53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.77-16.07H31.06V44.7a67.18,67.18,0,0,0,7.71-6.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.35,49.48V-16.07h-7.7V53a72.78,72.78,0,0,0,7.7-3.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.45,67.36l-5,3.09,8.43,14,5.63-3.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.91,77.54l-4.43-8.86H81.36l-.42,2.13L77.81,77.3l-3.38,2.27-1.39,7L61.23,100.48l9.22-.74-1.67,8.48L72,106l.32,3.91,5.6-6.58,5.15,7.68,3.52-17.88,4.65-5.46L91,83.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-125.41-16.07h-18.16l1.63,4.89-10.7,37.48-10.72-37.48,1.63-4.89h-18.16L-175-9.55l14.91,52.15-1.64,4.89h18.16l-1.63-4.89,14.9-52.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M182.3-11.53l3-4.54H167.16l3,4.54V43l-3,4.54h18.16l-3-4.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagVI;
exports["default"] = _default;